import PropTypes from 'prop-types'

const SpaceLandingIcon = ({ children }: any) => <div className="icon-container">{children}</div>

SpaceLandingIcon.displayName = 'SpaceLandingIcon'

SpaceLandingIcon.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.object)])
}

SpaceLandingIcon.defaultProps = {
  children: null
}

export default SpaceLandingIcon
